(function () {
  'use strict';
  var script = document.currentScript;
  var base = script && script.src ? script.src.replace(/stone-currency\.js.*$/, '') : '';
  if (!document.getElementById('sa-email-js')) {
    var emailScript = document.createElement('script');
    emailScript.id = 'sa-email-js';
    emailScript.src = base + 'stone-email.js';
    emailScript.defer = true;
    document.head.appendChild(emailScript);
  }

  var CURRENCIES = {
    INR: { sym: '₹', label: 'INR – Indian Rupee' },
    USD: { sym: '$', label: 'USD – US Dollar' },
    GBP: { sym: '£', label: 'GBP – British Pound' },
    EUR: { sym: '€', label: 'EUR – Euro' },
    AED: { sym: 'AED ', label: 'AED – UAE Dirham' },
    AUD: { sym: 'A$', label: 'AUD – Australian Dollar' },
    RUB: { sym: '₽', label: 'RUB – Russian Rouble' }
  };
  var RATES = { INR: 1, USD: 0.0113, GBP: 0.0085, EUR: 0.0097, AED: 0.0415, AUD: 0.0172, RUB: 0.91 };
  var EURO_COUNTRIES = 'AT BE BG CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK AD MC SM VA AX BL GF GP MF MQ PM RE YT'.split(' ');
  var TEXT_PRICE = /(?:Rs\.\s*|₹\s*)(\d[\d,]*(?:\.\d{1,2})?)/g;
  var textPrices = new WeakMap();
  var filterInputs = new WeakMap();
  var manual = false;
  var currency = 'USD';
  var timer;

  function read(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }
  function write(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }
  function currencyForCountry(country) {
    country = String(country || '').toUpperCase();
    var map = { IN: 'INR', US: 'USD', GB: 'GBP', AE: 'AED', AU: 'AUD', RU: 'RUB' };
    return map[country] || (EURO_COUNTRIES.indexOf(country) !== -1 ? 'EUR' : 'USD');
  }
  function number(value) {
    if (String(value || '').trim() === '') return null;
    var result = Number(String(value).replace(/,/g, '').trim());
    return Number.isFinite(result) ? result : null;
  }
  function displayNumber(value) {
    return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function rate() { return RATES[currency] || 1; }
  function displayPrice(inr) {
    return CURRENCIES[currency].sym + Math.round(inr * rate()).toLocaleString('en-US');
  }

  var saved = read(window.localStorage, 'sa_currency');
  if (saved && CURRENCIES[saved]) {
    currency = saved;
    manual = true;
  } else {
    var country = read(window.sessionStorage, 'sa_detected_country');
    if (country) currency = currencyForCountry(country);
  }

  function convertText() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.closest('script,style,noscript,template,textarea,#sa-cur-bar')) continue;
      var value = node.nodeValue;
      var item = textPrices.get(node);
      TEXT_PRICE.lastIndex = 0;
      if ((!item || value !== item.last) && TEXT_PRICE.test(value)) {
        item = { original: value, last: value };
        textPrices.set(node, item);
        TEXT_PRICE.lastIndex = 0;
        var first = TEXT_PRICE.exec(value);
        if (first) {
          parent.dataset.saInr = first[1].replace(/,/g, '');
          parent.dataset.saTpl = value;
        }
      }
      if (!item) continue;
      if (value !== item.last) {
        textPrices.delete(node);
        continue;
      }
      TEXT_PRICE.lastIndex = 0;
      var converted = currency === 'INR' ? item.original : item.original.replace(TEXT_PRICE, function (_, amount) {
        return displayPrice(Number(amount.replace(/,/g, '')));
      });
      if (node.nodeValue !== converted) node.nodeValue = converted;
      item.last = converted;
    }
  }

  function commitFilter(display, sendChange) {
    var raw = filterInputs.get(display);
    if (!raw) return;
    var typed = number(display.value);
    if (typed === null && display.value.trim() !== '') {
      display.value = raw.value ? displayNumber(number(raw.value) * rate()) : '';
      return;
    }
    var inr = typed === null ? null : Math.max(0, typed / rate());
    var maximum = number(raw.dataset.max);
    var minimum = number(raw.dataset.min);
    if (inr !== null && maximum !== null) inr = Math.min(inr, maximum);
    if (inr !== null && minimum !== null) inr = Math.max(inr, minimum);
    raw.value = inr === null ? '' : inr.toFixed(2);
    display.value = inr === null ? '' : displayNumber(inr * rate());
    display.dataset.saBaseValue = raw.value;
    if (sendChange) raw.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncPriceFilters() {
    document.querySelectorAll('price-facet-component').forEach(function (facet) {
      facet.querySelectorAll('input[name="filter.v.price.gte"],input[name="filter.v.price.lte"]').forEach(function (raw) {
        var display = raw.parentElement.querySelector('[data-sa-price-display]');
        if (!display) {
          display = raw.cloneNode(false);
          display.removeAttribute('name');
          display.removeAttribute('ref');
          display.removeAttribute('on:change');
          display.removeAttribute('data-min');
          display.removeAttribute('data-max');
          display.id = raw.id + '-local';
          display.type = 'text';
          display.dataset.saPriceDisplay = '1';
          raw.type = 'hidden';
          raw.hidden = true;
          raw.parentElement.insertBefore(display, raw.nextSibling);
          filterInputs.set(display, raw);
          display.addEventListener('input', function (event) { event.stopPropagation(); });
          display.addEventListener('change', function (event) {
            event.stopImmediatePropagation();
            commitFilter(display, true);
          });
          display.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
              event.preventDefault();
              event.stopImmediatePropagation();
              commitFilter(display, true);
            }
          });
        }
        var label = raw.parentElement.querySelector('.price-facet__label');
        if (label) {
          label.htmlFor = display.id;
          if (label.textContent !== CURRENCIES[currency].sym) label.textContent = CURRENCIES[currency].sym;
        }
        var originalLabel = raw.getAttribute('aria-label') || '';
        display.setAttribute('aria-label', originalLabel + ' (' + currency + ')');
        if (document.activeElement !== display || display.dataset.saCurrency !== currency) {
          var baseValue = number(raw.value);
          var basePlaceholder = number(raw.getAttribute('placeholder'));
          var nextValue = baseValue === null ? '' : displayNumber(baseValue * rate());
          if (display.value !== nextValue) display.value = nextValue;
          display.placeholder = basePlaceholder === null ? '0' : displayNumber(basePlaceholder * rate());
          display.dataset.saCurrency = currency;
          display.dataset.saBaseValue = raw.value;
        }
      });
    });
  }

  function buildUI() {
    var bar = document.getElementById('sa-cur-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'sa-cur-bar';
      bar.innerHTML = '<span class="sa-cur-note">Ships worldwide · Prices in</span><span id="sa-cur"><span class="sa-cur-chip"><span class="sa-cur-code"></span><svg width="8" height="5" viewBox="0 0 8 5" aria-hidden="true"><path d="M0 0l4 5 4-5z" fill="currentColor"/></svg></span><select aria-label="Currency" title="Prices are an approximate conversion. Checkout is in INR."></select></span>';
      var header = document.getElementById('header-group') || document.body;
      header.insertBefore(bar, header.firstChild);
    }
    var select = bar.querySelector('select');
    if (!select) return;
    if (!select.dataset.saBuilt) {
      select.textContent = '';
      Object.keys(CURRENCIES).forEach(function (code) {
        var option = document.createElement('option');
        option.value = code;
        option.textContent = CURRENCIES[code].label;
        select.appendChild(option);
      });
      select.dataset.saBuilt = '1';
      select.addEventListener('change', function () {
        if (!CURRENCIES[select.value]) return;
        manual = true;
        currency = select.value;
        write(window.localStorage, 'sa_currency', currency);
        refresh();
      });
    }
    if (select.value !== currency) select.value = currency;
    var chip = bar.querySelector('.sa-cur-code');
    if (chip && chip.textContent !== currency) chip.textContent = currency;
    bar.dataset.currency = currency;
  }

  function refresh() {
    buildUI();
    convertText();
    syncPriceFilters();
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }
  function detectCountry() {
    if (manual || read(window.sessionStorage, 'sa_detected_country')) return;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 4000);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Country unavailable'); return response.json(); })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        var code = country && country.handle;
        if (!code) return;
        write(window.sessionStorage, 'sa_detected_country', code);
        if (!manual) { currency = currencyForCountry(code); refresh(); }
      })
      .catch(function () {})
      .finally(function () { clearTimeout(timeout); });
  }
  function loadRates() {
    var cached;
    try { cached = JSON.parse(read(window.localStorage, 'sa_rates') || 'null'); } catch (error) {}
    function applyRates(rates) {
      Object.keys(CURRENCIES).forEach(function (code) {
        var value = Number(rates[code]);
        if (Number.isFinite(value) && value > 0) RATES[code] = value;
      });
      RATES.INR = 1;
    }
    if (cached && cached.r) applyRates(cached.r);
    if (cached && Date.now() - cached.t < 43200000) return;
    fetch('https://open.er-api.com/v6/latest/INR')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data || !data.rates) return;
        applyRates(data.rates);
        write(window.localStorage, 'sa_rates', JSON.stringify({ t: Date.now(), r: RATES }));
        refresh();
      }).catch(function () {});
  }
  function boot() {
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, characterData: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    detectCountry();
    loadRates();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
